module.exports = __webpack_public_path__ + "static/media/image-preview-chat-mo-hero.03d5ee80.png";